var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsFeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17C8.5 17.8284 7.82843 18.5 7 18.5C6.17157 18.5 5.5 17.8284 5.5 17C5.5 16.1716 6.17157 15.5 7 15.5C7.82843 15.5 8.5 16.1716 8.5 17Z",
    fill: "#ED7F23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11C9.651 11.4553 12.5447 14.349 13 18M6 6C12.6274 6 18 11.3726 18 18M6 22H18C20.2091 22 22 20.2091 22 18V6C22 3.79086 20.2091 2 18 2H6C3.79086 2 2 3.79086 2 6V18C2 20.2091 3.79086 22 6 22Z",
    stroke: "#ED7F23",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsFeed);
export default __webpack_public_path__ + "static/media/news-feed.c242447257f8b9a1c3a1ca83f16ae1c1.svg";
export { ForwardRef as ReactComponent };